export enum PageAnchor {
  COMMENTS = '#comments',
}
